import React from 'react';

const LOGO_TOP   = 40;
const LOGO_W     = 190;
const LOGO_H     = 210;
const LOGO_CTR_Y = LOGO_TOP + Math.round(LOGO_H * 0.44);

export default function LoginSuccessScreen({ isAdmin }) {
  return (
    <div style={O.overlay}>
      <div style={O.bgAmbient}/>

      {/* ── Headline ── */}
      <div style={{ ...O.textBlock, animation: 'lsTextIn 0.75s cubic-bezier(0.175,0.885,0.32,1.1) 0.1s both' }}>
        <div style={O.eyebrow}>ERP Intelligence Platform</div>
        <h1 style={O.headline}>
          Ask anything.<br/>
          Know everything.
        </h1>
        <p style={O.subline}>
          {isAdmin
            ? 'Admin access granted — loading panel…'
            : 'Welcome back — opening your workspace…'}
        </p>
      </div>

      {/* ── Stage ── */}
      <div style={O.stage}>

        {/* Halo ripple rings */}
        <div style={{ ...O.halo, width: 390, height: 390, animationDelay: '0.8s'  }}/>
        <div style={{ ...O.halo, width: 265, height: 265, animationDelay: '1.35s' }}/>
        <div style={{ ...O.halo, width: 158, height: 158, animationDelay: '1.9s'  }}/>

        {/* Logo card */}
        <div style={{ ...O.logoCard, animation: 'lsLogoIn 0.7s cubic-bezier(0.175,0.885,0.32,1.1) 0.38s both' }}>
          <img
            src="/logo.svg"
            alt="SolutionOne"
            style={{ width: 172, height: 'auto', objectFit: 'contain',
              filter: 'drop-shadow(0 0 20px rgba(27,94,59,0.65))' }}
          />
        </div>

      </div>

      <style>{`
        @keyframes lsTextIn {
          from { opacity:0; transform:translateY(-34px); }
          to   { opacity:1; transform:translateY(0); }
        }
        @keyframes lsLogoIn {
          from { opacity:0; transform:translateX(-50%) translateY(44px) scale(0.65);
                 box-shadow:0 0 0 rgba(0,0,0,0); }
          to   { opacity:1; transform:translateX(-50%) translateY(0) scale(1);
                 box-shadow:0 0 55px  rgba(139,92,246,1),
                            0 0 110px rgba(27,94,59,.78),
                            0 0 190px rgba(99,32,200,.46),
                            0 0 300px rgba(79,26,176,.26),
                            inset 0 1px 0 rgba(255,255,255,.32),
                            inset 0 0 44px rgba(255,255,255,.08); }
        }
        @keyframes lsFadeIn {
          from { opacity:0; }
          to   { opacity:1; }
        }
        @keyframes lsHaloRipple {
          0%   { transform:translate(-50%,-50%) scale(0.5);  opacity:0; }
          12%  { opacity:0.6; }
          100% { transform:translate(-50%,-50%) scale(1.28); opacity:0; }
        }
        @keyframes lsAmbient {
          0%,100% { opacity:1; }
          50%     { opacity:0.55; }
        }
      `}</style>
    </div>
  );
}

const O = {
  overlay: {
    position: 'fixed', inset: 0, zIndex: 9999,
    background: '#000',
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', justifyContent: 'center',
    overflow: 'hidden',
  },
  bgAmbient: {
    position: 'absolute', inset: 0, pointerEvents: 'none',
    background: 'radial-gradient(ellipse at 50% 64%, rgba(79,26,176,.28) 0%, transparent 62%)',
    animation: 'lsAmbient 3s ease-in-out infinite',
  },
  textBlock: {
    textAlign: 'center', position: 'relative', zIndex: 2, marginBottom: 44,
  },
  eyebrow: {
    fontSize: 11, fontWeight: 700, letterSpacing: '3px',
    color: '#1B5E3B', textTransform: 'uppercase', marginBottom: 14,
  },
  headline: {
    fontSize: 'clamp(40px, 6.5vw, 80px)', fontWeight: 800,
    color: '#fff', lineHeight: 1.08,
    margin: '0 0 16px', letterSpacing: '-1.5px',
  },
  subline: {
    fontSize: 13, color: 'rgba(255,255,255,.44)', margin: 0,
  },
  stage: {
    position: 'relative', width: 320, height: 310,
  },
  halo: {
    position: 'absolute',
    top: LOGO_CTR_Y, left: '50%',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(27,94,59,.55) 0%, transparent 70%)',
    pointerEvents: 'none',
    animation: 'lsHaloRipple 2.45s ease-out infinite',
    animationFillMode: 'both',
  },
  logoCard: {
    position: 'absolute',
    top: LOGO_TOP, left: '50%',
    width: LOGO_W, height: LOGO_H,
    borderRadius: 24,
    background: 'linear-gradient(145deg, rgba(255,255,255,.14) 0%, rgba(27,94,59,.22) 100%)',
    backdropFilter: 'blur(22px)', WebkitBackdropFilter: 'blur(22px)',
    border: '1px solid rgba(255,255,255,.20)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 3,
  },
};
